export default "__VITE_ASSET__b41216ce__"